import { Typography } from '@repo/ui';
import c from 'classnames';
import { Spinfinity } from 'components';
import { useCurrentKitAndTinyAccount } from 'hooks/useCurrentKitAndTinyAccount';
import { useMemo } from 'react';
import useActionPlanData from 'services/actionPlan/actionPlanData';
import { ActionPlanItem } from 'types/ActionPlan';
import { getActionsForSubMetric } from 'views/Results/Insights/SubMetricDetail/SubMetricDetail';
import { MainFindingItem } from './MainFindingItem';
import { useMainFindings } from './useMainFindings';

import styles from './MainFindings.module.scss';

export const MainFindings = () => {
  const { currentKitId } = useCurrentKitAndTinyAccount();
  const { data: mainFindingsData, isPending } = useMainFindings(currentKitId);
  const { data: allActions } = useActionPlanData({ kitId: currentKitId });

  const mainFindings = mainFindingsData?.mainFindings || [];

  const findingsWithActions = useMemo(() => {
    if (!mainFindings.length || !allActions?.length) return [];

    return mainFindings.map(finding => {
      const relatedActions: ActionPlanItem[] = finding.sample_health_id
        ? getActionsForSubMetric(allActions, finding.sample_health_id)
        : [];

      return {
        metric: {
          sample_health_id: finding.sample_health_id,
          user_value: finding.user_value,
          user_string: finding.user_string,
          evaluation_color: finding.evaluation_color,
          gvh: finding.gvh,
        },
        relatedActions,
      };
    });
  }, [mainFindings, allActions]);

  if (isPending) {
    return (
      <div className={styles.loadingContainer}>
        <Spinfinity />
      </div>
    );
  }

  if (!mainFindings.length) {
    return null;
  }

  return (
    <div className={c(styles.mainFindings, 'flex flex-column')}>
      <Typography variant='heading-s' className='mb-1' serif weight='medium'>
        Main findings
      </Typography>
      <Typography variant='body-s' serif className={styles.description}>
        These are the areas we recommend focusing on first:
      </Typography>
      <div className={styles.findingsContainer}>
        {findingsWithActions.map(({ metric, relatedActions }) => (
          <MainFindingItem
            key={metric.sample_health_id}
            metric={metric}
            kitId={currentKitId}
            relatedActions={relatedActions}
          />
        ))}
      </div>
    </div>
  );
};
